// components/Stats/CompletedCard.jsx
import React, { useEffect, useState } from "react";
import StatCard from "./statCard"
import { FaCheckCircle } from "react-icons/fa";
import { BarChart3 } from "lucide-react";
import axios from "axios";
import { courseContent } from "../../data/courseContent";

export default function CompletedCard({ count, onShowCompleted, totalStudents = 0, completedStudentsList = [] }) {
     const [loading, setLoading] = useState(false)
    
    const completionRate = totalStudents > 0 
        ? Math.min(Math.round((count / totalStudents) * 100), 100)
        : 0  // count is the number of completed students, calculate completion rate


        const handleClick = async () => {
        setLoading(true);
        try {
            if (onShowCompleted) await onShowCompleted();
        } finally {
            setLoading(false);
        }
    };


  return (
    <StatCard
      icon={<FaCheckCircle className="w-6 h-6" />}
      label="Completed Students"
      value={count}
      subtitle={completionRate + "% completion rate"}
      actionText="View Analytics"
      actionIcon={<BarChart3 className="w-4 h-4" />}
      actionVariant="outline"
      actionOnClick={handleClick}
      loading={loading}
    />
  );
}

